import { assert } from "@/common/assert";
import PhotoSwipe from "photoswipe";
import PhotoSwipeUI_Default from "photoswipe/dist/photoswipe-ui-default";
import { ensureAttributesForSelector } from "@/pages/base/utils";
import "./vendor.photoswipe.scss";
import "./index.scss";
import jqueryDataUtil from "@/common/jqueryDataUtil";
import { parseSizeFromImageUrl } from "@/pages/base/imageUtils";
import { photoSwipeHtml } from "./photoswipeHtml";

//插件使用方法 需要三个条件 两个class 一个data-photoswipe-full-url属性标记；
// 1 图片列表容器上标class js-photoswipe-container;
// 2 每个预览的图片上标class image-photoswipe;
// 3 每个预览的图片上标data-photoswipe-full-url属性，值为大图src；

//see https://photoswipe.com/documentation/getting-started.html
interface PhotoSwipeElement {
    title?: string;
    /**
     * path to image
     */
    src: string;
    /**
     * path to small image placeholder, large image will be loaded on top
     */
    msrc: string;
    thumbnail: HTMLImageElement;
    w: number;
    h: number;
}

//产品或帖子正文中的photoswipe查看大图
$(function () {
    let $pswp = $(".pswp");
    if (!$pswp.length) {
        $pswp = $(photoSwipeHtml).appendTo(document.body);
    }
    const pswpElement = $pswp.get(0);
    const CONTENT_IMG_SELECTOR = ".js-photoswipe-container";

    $(CONTENT_IMG_SELECTOR).each(function (index, el) {
        $(el)
            .find('img:not(".image-photoswipe")')
            .each(function (_index, element) {
                const $el = $(element);
                const thisSrc = $el.attr("src");
                if (/\.gif$/.exec(thisSrc)) return;
                assert(
                    !$el.attr("data-photoswipe-full-url"),
                    "should not have data-photoswipe-full-url before initialization",
                );
                $el.addClass("image-photoswipe").attr("data-photoswipe-full-url", thisSrc);
            });
    });

    ensureAttributesForSelector(".image-photoswipe", ["data-photoswipe-full-url"]);
    function parseThumbnailElements($contentImgElement: JQuery) {
        const items: PhotoSwipeElement[] = [];
        $contentImgElement.find(".image-photoswipe").each((_index, img) => {
            const $img = $(img);
            const photoswipeUrl = jqueryDataUtil.requiredString($img, "photoswipe-full-url");
            const largeImageSize = parseSizeFromImageUrl(photoswipeUrl) || {
                width: 500,
                height: 500,
            };
            const msrc = $img.attr("src") as string;
            assert(msrc, "msrc falsy");
            items.push({
                src: photoswipeUrl,
                msrc: msrc,
                thumbnail: img as HTMLImageElement,
                w: largeImageSize.width,
                h: largeImageSize.height,
            });
        });
        return items;
    }

    const openPhotoSwipe = function (index: number, contentImgElement: JQuery) {
        const items = parseThumbnailElements(contentImgElement);
        const contentImgs = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, {
            index: index,
            getThumbBoundsFn: function (idx) {
                const thumbnail = items[idx].thumbnail;
                const scrollTop = $(document).scrollTop();
                const rect = thumbnail.getBoundingClientRect();
                return {
                    x: rect.left,
                    y: rect.top + scrollTop,
                    w: rect.width,
                };
            },
        });
        contentImgs.init();
    };

    $(document).on("click", ".image-photoswipe", function (e) {
        const $target = $(e.target);
        const $clickedContentImg = $target.closest(CONTENT_IMG_SELECTOR);
        assert($clickedContentImg.length, "image-photoswipe must be within a js-photoswipe-container");
        const $allImageItems = $clickedContentImg.find(".image-photoswipe");
        const index = $allImageItems.index($target);
        assert(index > -1, "failed to find clicked content image");
        openPhotoSwipe(index, $clickedContentImg);
        return false;
    });
});
